@if (showBar() === false) {
  <portal-icon-button
    class="position-relative"
    [appendTo]="audio"
    [iconClass]="'far ' + (playing ? 'fa-stop' : 'fa-play')"
    [loading]="loading"
    [portalTippy]="'announcement.play' | translate"
    [progress]="progress$ | async"
    [showProgress]="playing"
    (onClick)="togglePlayback()"
    placement="top"
    style="z-index: 1"
  ></portal-icon-button>
}

@if (showBar()) {
  <div class="d-flex align-items-center">
    <portal-icon-button
      class="position-relative"
      [appendTo]="audio"
      [iconClass]="'far ' + (playing ? 'fa-stop' : 'fa-play')"
      [loading]="loading"
      [portalTippy]="'announcement.play' | translate"
      [progress]="progress$ | async"
      [showProgress]="false"
      (onClick)="togglePlayback()"
      placement="top"
      style="z-index: 1"
    ></portal-icon-button>
    <div class="flex-grow-1">
      <div class="progress">
        <div
          class="progress-bar"
          [attr.aria-valuenow]="progress$ | async"
          [style]="'width: ' + (progress$ | async) + '%'"
          aria-valuemax="100"
          aria-valuemin="0"
          role="progressbar"
        ></div>
      </div>
    </div>
    @if (allowDownload()) {
      <portal-file-download
        class="icon-button"
        [portalTippy]="'download' | translate"
        [url]="file()"
        btnClass="border-0 btn btn-icon btn--portal-link"
      >
        <i class="far fa-fw fa-arrow-to-bottom"></i>
      </portal-file-download>
    }
  </div>
}

<audio #audio [src]="audioSource" (ended)="ended()" (timeupdate)="updateProgress()"></audio>
